import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  /**
   * Récupération de l'objet user
   * - renvoie un objet vide si non connecté
   */
  async getUser() {
    const user = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_ACCOUNT
    );
    return user.data;
  },

  /**
   * Activation du switch
   * - renvoie un objet User
   */
  async switchUser(idUser) {
    const user = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_SWITCH_LOGIN +
        idUser
    );
    return user.data;
  },

  /**
   * Désactivation du switch
   * - renvoie un objet User
   */
  async unswitchUser() {
    const user = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_SWITCH_LOGOUT
    );
    return user.data;
  },
};
